(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // any open search (desktop inline box or the phone search sheet) keeps the header in place
      if (this.querySelector('predictive-search[open], .header__search details[open]')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
      requestAnimationFrame(() => this.setHeaderHeight());
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-dropdown-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Desktop dropdowns: CSS opens them on mouse hover; this adds keyboard and touch (aria-expanded).
  class HeaderDropdownMenu extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('button[aria-expanded]');
      this.buttons.forEach((button) =>
        button.addEventListener('click', (event) => {
          // a mouse already opened the list by hovering; a click would only fight the hover
          if (event.pointerType === 'mouse') return;
          if (button.getAttribute('aria-expanded') === 'true') this.close();
          else this.open(button);
        })
      );
      this.addEventListener('keydown', (event) => {
        const open = this.querySelector('[aria-expanded="true"]');
        if (event.key !== 'Escape' || !open) return;
        this.close();
        open.focus();
      });
      this.addEventListener('focusout', (event) => {
        const item = event.target.closest('.header__menu-details');
        if (item && !item.contains(event.relatedTarget)) this.close();
      });
      // the mouse takes over from a keyboard/touch-opened list, so two lists never show at once
      this.addEventListener('pointerover', (event) => event.pointerType === 'mouse' && this.close());
      // pointerdown, not click: iOS fires no click for taps on plain text
      this.onOutsideTap = (event) => !this.contains(event.target) && this.close();
      document.addEventListener('pointerdown', this.onOutsideTap);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.onOutsideTap);
    }

    open(button) {
      this.buttons.forEach((other) => other.setAttribute('aria-expanded', other === button));
    }

    close() {
      this.open(null);
    }
  }
  customElements.define('header-dropdown-menu', HeaderDropdownMenu);

  } catch(e) { console.error(e); }
})();
})();
